import { useInfiniteQuery } from '@tanstack/react-query'

import { getDocsVersionsYjs } from '@pepper/utils/src/api/editor/editor'
import { useShowMessage } from '../providers'

import { editorKeys } from './queryKey'

interface Parameter {
  data: {
    id: string
    apiType: PepperDocTypes
    startIndex: number
    states?: VersionStates[]
  }
  enabled?: boolean
}

const STALE_TIME_MS = 15 * 60 * 1000 // 15 mins

async function handleApiRequest(data: Parameter['data']) {
  const result: GetDocsVersionYJSResponse = await getDocsVersionsYjs(data)
  if (result.status !== 'ok') {
    throw new Error(result.error)
  }

  return result.data
}

/**
 * @deprecated useGetDocVersionsV2 should be used
 */
export function useGetDocVersions({ data, enabled }: Parameter) {
  const showMessage = useShowMessage()

  return useInfiniteQuery<GetDocsVersionYJSResponse['data']>({
    queryKey: editorKeys.versions(data.id),
    queryFn: ({ pageParam }) =>
      handleApiRequest({ ...data, startIndex: pageParam ?? 0 }),
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false,
    enabled: enabled ?? true,
    getNextPageParam: lastPage => {
      const nextStartIndex = lastPage.page.end
      return lastPage.total > nextStartIndex ? nextStartIndex : undefined
    },
    onError: () => {
      showMessage({ type: 'error', message: 'Failed to fetch versions.' })
    }
  })
}
